import { HandHoldingDollarSolidV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import { noNamer } from "../../../../Contacts/ModalViews/helpers";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import DataField from "./DataField";

const GabbiLoanCreatedActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";

  const match = activity.content.match(/^(.*status)\s+(.*)$/i);

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={HandHoldingDollarSolidV6}>
            Loan Record Created by Gabbi
          </CategoryContainer>
        }
        personName={noNamer(activity.data?.subjectFirstName, activity.data?.subjectLastName)}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <span className={STYLES.lineClamp3}>
          {match?.[1] ? match[1] : "Gabbi referred a lead to Envoy Mortgage and created a loan record"}{" "}
          <b className="tw-uppercase">{match?.[2] ? match[2] : ""}</b>.
        </span>
        <DataField
          label="Referred to"
          data={noNamer(activity.data?.referralFirstName, activity.data?.referralLastName)}
        />
      </div>
    </ActivityContainer>
  );
};

export default GabbiLoanCreatedActivity;

GabbiLoanCreatedActivity.propTypes = {
  ...activityCommonPropTypes,
};

GabbiLoanCreatedActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
